import { render, staticRenderFns } from "./ovrz1.vue?vue&type=template&id=eba4379c&scoped=true"
import script from "./ovrz1.vue?vue&type=script&lang=js"
export * from "./ovrz1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba4379c",
  null
  
)

export default component.exports